var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgThumbsUp16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9931 6.9402C16.0978 5.75129 14.9893 5.40436 14.5499 5.40436C12.8452 5.40378 11.1392 5.40436 9.43474 5.403C9.68008 4.86871 9.97936 3.4526 9.60278 1.5016C9.45402 0.73014 8.9988 0.217081 8.41875 0.227449C7.95203 0.235627 7.50578 0.595643 7.45883 1.04501C7.40781 1.53899 7.28632 2.2419 7.17163 2.72321C6.8517 4.06194 5.99504 5.77384 4.95905 6.66155C4.68631 6.89525 4.48705 7.22019 4.48705 7.57936V13.9249C4.48705 14.2856 4.68036 14.6202 4.98892 14.8069C5.40012 15.0558 5.59575 15.147 6.33029 15.1329C7.87201 15.1033 12.2754 15.129 13.0739 15.1239C13.6385 15.12 14.2018 14.8507 14.4728 14.1687C14.843 13.238 13.8889 12.7728 13.8889 12.7728C13.8889 12.7728 14.9335 12.8244 15.1718 11.8875C15.4166 10.9262 14.4561 10.5453 14.4561 10.5453C15.1058 10.4744 15.5217 10.3052 15.6791 9.71958C15.8644 9.02952 15.4205 8.51183 14.718 8.21196C14.8239 8.20164 15.8965 8.02845 15.9931 6.9402ZM2.51585 5.80487H0.529608C0.237155 5.80487 0 6.04222 0 6.33448V14.8311C0 15.124 0.237349 15.3607 0.529608 15.3607H2.51585C2.8083 15.3607 3.04546 15.1238 3.04546 14.8311V6.33448C3.04546 6.04222 2.80869 5.80487 2.51585 5.80487Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsUp16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;